import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SectionContent } from '@menu/components';
import { sendToGA } from '@react-shared/helpers/send-to-ga';

class Subcategory extends Component {
  constructor(props) {
    super(props);

    let currentPageUrl = $('.js-menu').data('currentPage');
    let currentPageSection = props.categories.find((category) => {
      return category.items.find((item) => {
        return item.url == currentPageUrl || (item.link && item.link.url == currentPageUrl);
      })
    });

    this.state = {
      categories: props.categories,
      selectedSection: currentPageSection || props.categories[0],
      clicked: false
    };

    this.categoryChange = this.categoryChange.bind(this);
  }

  async categoryChange(selected) {
    sendToGA({
      event: 'Menu',
      action: 'MenuViewSelect',
      type: 'sub'
    });

    let clicked = true;

    if (this.props.mobile && this.state.clicked) {
      clicked = selected.id !== this.state.selectedSection.id;
    }

    await this.setState({
      clicked: clicked,
      selectedSection: selected
    });

    if (clicked) {
      this.props.clickSection('.selected-subcat-label');
    }
  }

  isSelectedSubcategory(categoryId) {
    if (this.state.clicked || !this.props.mobile) {
      return this.state.selectedSection.id === categoryId;
    } else {
      // used for mobile, sections are closed by default
      return false;
    }
  }

  render() {
    return (
      <section className="nav-groups flex-l flex-jc-sb-l flex-w-w-l justify-center">
        <div className="nav-sidebar flex-l flex-jc-sb-l flex-w-w-l col-lg-5-1">
          {this.state.categories.map((category, index) => (
            <div
              className={`nav-child-option ${this.isSelectedSubcategory(category.id) ? 'nav-child-option--active' : ''}`}
              key={"category-" + this.props.parentId + "-subcategory-" + category.id + "-" + index}
            >
              <input
                type="radio"
                name="child-nav"
                id={"category-" + this.props.parentId + "-subcategory-" + category.id + "-" + index}
                className="nav-child-input"
                role="button"
                defaultChecked={this.isSelectedSubcategory(category.id)}
              />
              <label
                htmlFor={"category-" + this.props.parentId + "-subcategory-" + category.id + "-" + index}
                className={`nav-child ${this.isSelectedSubcategory(category.id) ? 'selected-subcat-label' : ''}`}
                onClick={() => this.categoryChange(category)}
              >
                <span>
                  {category.sectionName}
                </span>
              </label>
              {this.props.mobile && this.isSelectedSubcategory(category.id) && this.state.clicked && (
                <div className="db-l flex-l flex-jc-sb-l flex-w-w-l col-lg-5-4">
                  <SectionContent
                    content={this.state.selectedSection.items}
                    sectionId={this.state.selectedSection.id}
                    featuredItem={this.state.selectedSection.featuredItem}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
        {!this.props.mobile && (
          <div className={`${this.state.clicked ? '' : 'dn'} ${this.state.selectedSection.items.find((i) => i.kind == "heading") ? '' : 'no-headings'} db-l flex-l flex-jc-sb-l flex-w-w-l col-lg-5-4`}>
            <SectionContent
              content={this.state.selectedSection.items}
              sectionId={this.state.selectedSection.id}
              featuredItem={this.state.selectedSection.featuredItem}
            />
          </div>
        )}
      </section>
    );
  }
}

Subcategory.propTypes = {
  selected: PropTypes.bool,
  parentId: PropTypes.number.isRequired,
  categories: PropTypes.any.isRequired,
  mobile: PropTypes.bool.isRequired,
  clickSection: PropTypes.func.isRequired
};

export default Subcategory;
